export default "__VITE_ASSET__g4hwkso6__"